import React, { PureComponent } from 'react'
import { Tooltip, Modal, Col, Row, Button, Table, OverlayTrigger } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputSelect from '../../commons/form/InputSelect'
import InputText from '../../commons/form/InputText'
import InputNumber from '../../commons/form/InputNumber'
import { isJsonString, handleKeyDown } from '../../../util/utils'
import SignatureEntityModalPage from '../../../containers/masters/SignatureConfig/SignatureEntityModalPage'

class SignatureConfigMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.signatureConfig)
    }
  }

  componentDidMount () {
    this.props.actions.fetchDocumentTypeUseCombo()
  }

  submitSignatureConfig (values) {
    const signatureConfig = {
      documentTypeUseId: values.documentTypeUseId,
      code: values.code,
      objectId: values.objectId,
      objectData: values.objectData,
      signDocumentConfigurationId: this.props.signatureConfig?.signDocumentConfigurationId
    }
    this.props.actions.submitSignatureConfig(signatureConfig)
  }

  render () {
    const {
      t, handleSubmit,
      showModal,
      signatureConfig,
      combos: { documentTypeUseCombo },
      actions: {
        closeSignatureConfigurationMasterModal,
        openEditSignatureEntityModal,
        deleteSignatureEntity
      }
    } = this.props
    const tKey = 'MASTERS.SIGNATURE_CONFIG_MASTERS.MODAL.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)

    return (
      <>
        <Modal
          id="signatureConfigMasterModal"
          className="_nf"
          show={showModal}
          onHide={closeSignatureConfigurationMasterModal}
          backdrop={'static'}>
          <form autoComplete="off"
            onSubmit={handleSubmit(this.submitSignatureConfig.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
            <Modal.Header
              closeButton
              onHide={closeSignatureConfigurationMasterModal}
            >
              <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="search-form">
                <Field
                  component={InputSelect}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  name="documentTypeUseId"
                  controlLabel={t(`${tKey}DOCUMENT_TYPE_USE`)}
                  placeholder={t(`${tKey}DOCUMENT_TYPE_USE`)}
                  valueKey="id"
                  labelKey="value"
                  options={documentTypeUseCombo}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="code"
                  name="code"
                  controlLabel={t(`${tKey}CONFIG_CODE`)}
                  placeholder={t(`${tKey}CONFIG_CODE`)}
                />
                <Field
                  component={InputNumber}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="objectId"
                  name="objectId"
                  controlLabel={t(`${tKey}OBJECT_ID`)}
                  placeholder={t(`${tKey}OBJECT_ID`)}
                  valueKey="id"
                  labelKey="value"

                />
                <Field
                  component={InputText}
                  colWidth={100} // 25, 33, 50, 75, 100 default=25
                  id="objectData"
                  name="objectData"
                  controlLabel={t(`${tKey}OBJECT_DATA`)}
                  placeholder={t(`${tKey}OBJECT_DATA`)}
                />
              </div>

              <Row className="inputs-wrapper entityTypeTable">
                <Col sm={12} className="custom-width-col">
                  <h5>{t(`${tKey}SIGN_ENTITIES`)}</h5>
                  <Table className="editable-table" hover responsive>
                    <thead>
                      <tr>
                        <th className='alignC'>
                          {t(`${tKey}ORDER`)}
                        </th>
                        <th>
                          {t(`${tKey}SIGNATURE_TYPE`)}
                        </th>
                        <th>
                          {t(`${tKey}SIGNATURE_ENTITY_TYPE`)}
                        </th>
                        <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {signatureConfig?.signEntities && signatureConfig?.signEntities.map((signatureConfigEntity, idx) => (
                        <tr key={idx}>
                          <td className='alignC'>{signatureConfigEntity.order}</td>
                          <td>{signatureConfigEntity.signType}</td>
                          <td>{signatureConfigEntity.signEntityType}</td>
                          <td className='actions'>
                            <div>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn' onClick={() => openEditSignatureEntityModal(signatureConfigEntity)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                <a className='_Btn cancel stk o-icn' onClick={() => deleteSignatureEntity(signatureConfigEntity)}>
                                  <i className="iDocIcon-delete-forever" />
                                </a>
                              </OverlayTrigger>
                            </div>
                          </td>
                        </tr>
                      ))
                      }
                      {(signatureConfig?.signEntities === null ||
                        signatureConfig?.signEntities === undefined ||
                        signatureConfig?.signEntities?.length === 0) &&
                        <tr>
                          <td colSpan={7}>
                            <p className="no_results">{t('MASTERS.SIGNATURE_CONFIG_MASTERS.RESULTS_NOT_FOUND')}</p>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </Table>
                  <div className='flexInLine al-L'>
                    <Button
                      className="_Btn new"
                      onClick={() => openEditSignatureEntityModal(
                        { signDocumentConfigurationId: signatureConfig?.signDocumentConfigurationId }
                      )}
                      disabled={!signatureConfig?.signDocumentConfigurationId}
                    >
                      <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <Col className="flexInLine al-R">
                <Button
                  id="role-modal-submit-button"
                  className="_Btn new"
                  type="submit"
                  disabled={this.props.pristine}>
                  {t(`${tKey}SUBMIT_BUTTON`)}
                </Button>
                <Button
                  id="role-modal-submit-button"
                  className="_Btn cancel"
                  type="reset"
                  onClick={closeSignatureConfigurationMasterModal}>
                  {t(`${tKey}CANCEL_BUTTON`)}
                </Button>

              </Col>
            </Modal.Footer>
          </form>
        </Modal>
        <SignatureEntityModalPage/>
      </>
    )
  }
}

export default reduxForm({
  form: 'editSignatureConfiguration',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.SIGNATURE_CONFIG_MASTERS.VALIDATION.'
    if (values.objectData && !isJsonString(values.objectData)) {
      error.objectData = props.t(`${tKey}OBJECT_DATA`)
    }
    if (!values.documentTypeUseId) {
      error.documentTypeUseId = props.t(`${tKey}DOCUMENT_TYPE_USE_REQUIRED`)
    }
    if (!values.code) {
      error.code = props.t(`${tKey}CODE`)
    }

    return Object.keys(error).length > 0 ? error : {}
  }
})(SignatureConfigMasterModal)
